<template>
  <div>
    <serveur-info :erreur="error" />
    <my-notification :icon="'hubzilla'">
      <template #title>
        {{ $t('compCarbonFormsRactivitiesMain.title-1') }}
      </template>
      <div class="content">
        <p>
          <span v-html="$t('compCarbonFormsRactivitiesMain.info-2')" />
          <strong>{{ year }}</strong
          >.
        </p>
      </div>
    </my-notification>
    <br />
    <b-notification :has-icon="true" icon="info" :closable="false">
      <span v-html="$t('compCarbonFormsRactivitiesMain.info-3')" />
    </b-notification>

    <ractivities-table
      @edit="edit"
      @update="$emit('is-modified', true)"
      @del="del"
      data-testId="ractivities-table"
    />

    <ractivity-modal
      v-if="ractivity !== null"
      :displayModal="displayModal"
      :ractivity="ractivity"
      :modeCreation="modeCreation"
      @close="closeModal"
      @update="update"
      @add="add"
    />
    <br />
    <nav class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="buttons">
          <b-button
            class="button"
            icon-left="plus"
            :disabled="isSubmitted"
            @click="displayAddForm()"
            data-testId="new-ractivity"
          >
            {{ $t('add') }}
          </b-button>
          <b-button
            class="level-item"
            :icon-left="validSavedIcon"
            :disabled="!flags.isModified"
            type="is-primary"
            @click="validate()"
            data-testId="save-ractivities"
          >
            <span v-if="authStore.isAuthenticated">{{ $t('save') }}</span>
            <span v-else>{{ $t('validate') }}</span>
          </b-button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Modules from '@/models/Modules.js'
import { ResearchActivity, toList } from '@/models/carbon/ResearchActivity.js'
import { useGHGIStore } from '@/stores/ghgi.js'
import { useAuthenticationStore } from '@/stores/authentication.js'

export default {
  name: 'Main',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue'),
    'serveur-info': () => import('@/components/ServeurInfo.vue'),
    'ractivity-modal': () =>
      import('@/components/carbon/forms/ractivities/Modal.vue'),
    'ractivities-table': () =>
      import('@/components/carbon/forms/ractivities/Table.vue')
  },
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    flags: {
      type: Object
    }
  },
  data () {
    return {
      error: '',
      modeCreation: false,
      displayModal: false,
      ractivity: null
    }
  },
  setup () {
    const ghgiStore = useGHGIStore()
    const authStore = useAuthenticationStore()
    return { ghgiStore, authStore }
  },
  computed: {
    module: function () {
      return Modules.RACTIVITIES
    },
    year: function () {
      return parseInt(this.ghgiStore.item.year)
    },
    validSavedIcon: function () {
      let icon = null
      if (this.authStore.isAuthenticated) {
        icon = 'save'
      } else {
        icon = 'check'
      }
      return icon
    },
    isSubmitted: function () {
      return this.ghgiStore.item.isSubmitted
    },
    ractivities: function () {
      return this.ghgiStore.items(Modules.RACTIVITIES)
    }
  },
  methods: {
    validate: function () {
      let self = this
      if (this.ghgiStore.invalidItems(Modules.RACTIVITIES).length !== 0) {
        this.$buefy.dialog.confirm({
          title: self.$t('compCarbonFormsRactivitiesMain.title-2'),
          message: self.$t('compCarbonFormsRactivitiesMain.info-1'),
          confirmText: self.$t('validate'),
          cancelText: self.$t('cancel'),
          canCancel: ['escape', 'button', 'outside'],
          onConfirm: function () {
            self.ghgiStore.deleteInvalidItems(Modules.RACTIVITIES)
            self.subValidate()
          },
          onCancel: function () {
            self.subValidate()
          }
        })
      } else {
        this.subValidate()
      }
    },
    subValidate: function () {
      if (this.authStore.isAuthenticated) {
        const loadingComponent = this.$buefy.loading.open({
          container: null
        })
        this.ghgiStore
          .saveItems(Modules.RACTIVITIES)
          .then((data) => {
            loadingComponent.close()
            this.$emit('is-valid', this.ractivities.length > 0)
            this.$emit('is-modified', false)
            this.error = ''
            window.scrollTo(0, 0)
            this.$buefy.toast.open({
              type: 'is-light',
              message: this.$t('compCarbonFormsRactivitiesMain.save-msg')
            })
          })
          .catch((error) => {
            loadingComponent.close()
            this.$emit('is-valid', false)
            this.error = error.response.data
          })
      } else {
        this.$emit('is-valid', this.ractivities.length > 0)
        this.$emit('is-modified', false)
      }
    },
    displayAddForm: function () {
      this.modeCreation = true
      this.ractivity = new ResearchActivity()
      this.displayModal = true
    },
    closeModal: function () {
      this.displayModal = false
      this.ractivity = null
    },
    add: function (item) {
      // ractivities are store as a flat list
      let items = toList(item)
      items.forEach((i) => {
        this.ghgiStore.addItem({
          module: Modules.RACTIVITIES,
          item: i
        })
      })
      this.$emit('is-modified', true)
      this.closeModal()
    },
    update: function (obj) {
      let objsFrom = toList(obj.from)
      let objsTo = toList(obj.to)
      this.ghgiStore.deleteItems({
        module: Modules.RACTIVITIES,
        items: objsFrom
      })
      for (let item of objsTo) {
        this.ghgiStore.addItem({
          module: Modules.RACTIVITIES,
          item: item
        })
      }
      this.$emit('is-modified', true)
      this.closeModal()
    },
    del: function (items) {
      for (let item of items) {
        let iitems = toList(item)
        this.ghgiStore.deleteItems({
          module: this.module,
          items: iitems
        })
      }
    },
    edit: function (item) {
      this.modeCreation = false
      this.ractivity = item
      this.displayModal = true
    }
  }
}
</script>
